import { useRef } from 'react';
import Image from 'components/shared/image/image';
import classNames from 'classnames';
import RichText from 'components/shared/richtext';
import Button from 'components/shared/button';
import handleDrag from 'lib/utils/handleDrag';
import useIsMobile from 'hooks/utils/useIsMobile';
import styles from './gallerySlider.module.scss';

const GallerySlider = ({ data, locale }) => {
  const { title, subtitle, gallery, align } = data;
  const carouselRef = useRef(null);
  const isMobile = useIsMobile();

  const getAlign = () => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      default:
        return 'center';
    }
  };

  const dragHandler = e => {
    if (isMobile) return;
    const { scrollLeft } = carouselRef.current;
    handleDrag(e, carouselRef, {
      leftSideCallback: (ev, delta) => {
        carouselRef.current.scrollLeft = scrollLeft - delta.x;
      },
      rightSideCallback: (ev, delta) => {
        carouselRef.current.scrollLeft = scrollLeft - delta.x;
      },
    });
  };

  return (
    <section className={styles.gallerySliderSection} style={{ 'align-items': getAlign() }}>
      <span className={styles.titleAndTextWrapper}>
        {title && <h2 className={styles.gallerySliderTitle}>{title}</h2>}
        {subtitle && <h3 className={styles.gallerySliderSubtitle}>{subtitle}</h3>}
      </span>
      <div
        role="tablist"
        className={styles.carouselWrapper}
        ref={carouselRef}
        tabIndex={0}
        onPointerDown={e => dragHandler(e)}
      >
        <div className={classNames(styles.galleryContainer)}>
          {gallery.map(item => (
            <div className={styles.galleryItem}>
              <Image draggable={false} src={item.media.image} layout="responsive" loading="lazy" />
              {item.title && <div className={styles.galleryItemTitle}>{item.title}</div>}
              {item.text?.json && (
                <div>
                  <RichText text={item.text?.json} />
                </div>
              )}
              {item.button && (
                <Button locale={locale} button={item.button} className={styles.galeryButton} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySlider;
